import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import {
  Button,
  DynamicImage,
  Input,
  Modal,
} from "src/views/shared/components";
import { tx } from "src/libs/i18n";
import { ISingleWordpressArticle, ISingleWordpressDocument } from "src/models";
import { UserCollectionStore } from "src/stores";
import * as styles from "./EditUserCollectionModal.module.scss";

interface EditUserCollectionModalProps {
  userCollectionStore?: UserCollectionStore;
}
@inject("userCollectionStore")
@observer
export class EditUserCollectionModal extends Component<EditUserCollectionModalProps> {
  renderForm = () => {
    const { validate, formData } = this.props.userCollectionStore;

    if (!formData) {
      return null;
    }

    return (
      <>
        <Input
          className={styles.input}
          type="text"
          label={tx("misc.collectionTitle")}
          placeholder={tx("misc.collectionTitle")}
          htmlFor="EditUserCollectionModalTitle"
          value={formData.title.value}
          onChange={(value) => (formData.title.value = value)}
          onBlur={() => validate(formData.title)}
          error={formData.title.valid === false}
        />

        <Input
          className={styles.input}
          type="textarea"
          label={tx("misc.description")}
          placeholder={tx("misc.description")}
          htmlFor="EditUserCollectionModalDescription"
          value={formData.description.value}
          onChange={(value) => (formData.description.value = value)}
          onBlur={() => validate(formData.description)}
        />
      </>
    );
  };

  getImage = (document: ISingleWordpressArticle | ISingleWordpressDocument) => {
    let image = null;
    switch (document.nodeType) {
      case "Document":
        image = document.documentThumbnail?.image;
        break;

      case "Article":
        image = document.articleFields?.imageGroup;
        break;
    }

    return image;
  };

  render() {
    const {
      updateCollection,
      isOpen,
      isUploadValid,
      onCloseUpdateModal: onClose,
      onUpdate,
    } = this.props.userCollectionStore;

    let cardImage = updateCollection?.userCollectionFields?.collectionPosts
      ?.map(this.getImage)
      .find(Boolean);

    return (
      <Modal open={isOpen} onClose={onClose} className={styles.wrapper}>
        <div className={styles.padding}>
          <DynamicImage
            image={cardImage}
            size="mediumLarge"
            className={styles.coverImage}
            alt={"card-image"}
          />

          <h2 className={styles.title}>{updateCollection?.title}</h2>

          {this.renderForm()}

          <Button
            className={styles.submitButton}
            size="large"
            color="red"
            onClick={onUpdate}
            disabled={!isUploadValid}
          >
            {tx("EditUserCollectionModal.saveButton")}
          </Button>
        </div>
      </Modal>
    );
  }
}
